export default {
  validation: {
    VALIDATION: 'Validation',
    INVALID: 'Invalid import',
    INVALID_EMPLOYEEID: 'Invalid employee number',
    INVALID_DATE: 'Invalid date',
    INVALID_END_DATE: 'Invalid end date',
    INVALID_START_DATE: 'Invalid start date',
    INVALID_RANGE: `Invalid range`,
    END_DATE_BEFORE_START_DATE: 'End date is before start date',
    START_IN_PAST: 'Start date is in the past',
    INVALID_TIME: 'Invalid time',
    INVALID_START_TIME: 'Invalid start time',
    INVALID_END_TIME: 'Invalid end time',
    INVALID_REQUEST_TYPE: 'Invalid request type',
    INVALID_CODE: 'Invalid code. Code can only contain letters, numbers, hyphens ( - ) or underscores ( _ ), and no spaces',
    INVALID_STATUS: 'Invalid status',
    CODE_NOT_UNIQUE: `Code must be unique`,
    INVALID_DEPARTMENTS: `Invalid department codes`,
    INVALID_POSITIONS: `Invalid position codes`,
    INVALID_POSITION_CODE: `Invalid position code`,
    INVALID_PROJECT_CODE: `Invalid project code`,
    INVALID_REQUIRED_POSITIONS: `Invalid required positions codes`,
    INVALID_LOCKEDUSERS: `Invalid locked users employee numbers`,
    INVALID_PREFERREDUSERS: `Invalid preferred users employee numbers`,
    INVALID_BLOCKEDUSERS: `Invalid blocked users employee numbers`,
    INVALID_REQUIREDATTRIBUTES: `Invalid required attributes import codes`,
    INVALID_PREFERREDATTRIBUTES: `Invalid preferred attributes import codes`,
    INVALID_TAGS: `Invalid tag codes`,
    INVALID_WAGEPREMIUMS: `Invalid wage premium codes`,
    INVALID_POSITION_FOR_PROJECT: `Position not required for project`,
    INVALID_DEFAULT_SHIFT_TAGS: `Invalid shift tags codes`
  }
}
